import type { MouseEvent } from "react";
import clsx from "clsx";
import type { FaClientListItem } from "@/services/api/agentic-v2";
import { VirtualList } from "@/components/mission-control/VirtualList";
import { ClientRow } from "./ClientRow";

/** Initial row height before DOM measurement; real heights are measured at runtime. */
export const CLIENT_ROW_ESTIMATE_PX = 72;

export interface ClientsVirtualListProps {
  clients: FaClientListItem[];
  refreshing: boolean;
  onClientClick: (client: FaClientListItem) => void;
  onClientContextMenu?: (event: MouseEvent, client: FaClientListItem) => void;
  scrollElement: HTMLDivElement | null;
  scrollReady: boolean;
  listKey?: string;
  className?: string;
}

/** Virtualised client rows — spacing and measurement handled by the shared ``VirtualList``. */
export function ClientsVirtualList({
  clients,
  refreshing,
  onClientClick,
  onClientContextMenu,
  scrollElement,
  scrollReady,
  listKey,
  className,
}: ClientsVirtualListProps) {
  return (
    <VirtualList
      className={clsx(
        "divide-y divide-white/5 transition-opacity",
        refreshing ? "opacity-60" : "opacity-100",
        className,
      )}
      items={clients}
      getKey={(client) => client._id}
      estimateSize={() => CLIENT_ROW_ESTIMATE_PX}
      scrollElement={scrollElement}
      scrollReady={scrollReady}
      listKey={listKey}
      renderItem={(client) => (
        <div onContextMenu={onClientContextMenu && ((event) => onClientContextMenu(event, client))}>
          <ClientRow client={client} onClick={onClientClick} />
        </div>
      )}
    />
  );
}
